import get from 'lodash.get';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import KeycloakClient from './KeycloakClient';
import MASClient from './MASClient';
import { SSO_AUTH_TOKEN, BEARER, HTTP_RESPONSE_CODE } from '../../../constants/shared/ApiConstants';

const graphqlApiUrl = 'https://mclass-enrollment.mclass.amplify.com/graphql';

export const errorHandler = error => {
    const networkError = get(error, 'networkError', {}) || {};
    const graphQLErrors = get(error, 'graphQLErrors', []) || [];
    const isAuthenticationError = graphQLErrors.some(
        ({ errorType }) => errorType === 'AuthenticationError',
    );
    if (networkError.statusCode === HTTP_RESPONSE_CODE.UNAUTHORIZED || isAuthenticationError) {
        return KeycloakClient.logout();
    }
    throw error;
};

const initApolloClient = () => {
    const httpLink = createHttpLink({
        uri: graphqlApiUrl.startsWith('{creds')
            ? process.env.REACT_APP_GRAPHQL_API_URL
            : graphqlApiUrl,
    });
    const authLink = setContext((_, { headers }) => ({
        headers: {
            ...headers,
            ...(KeycloakClient.isMasUser() && {
                custom: `${SSO_AUTH_TOKEN}=${MASClient.getMasToken()}`,
            }),
            authorization: `${BEARER}${KeycloakClient.getToken()}`,
        },
    }));
    return new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache({ addTypename: false }),
    });
};

export default initApolloClient();
